import { useQuery } from '@apollo/client';
import { InvoiceState } from 'containers/SettlementRequest/graphQL/types';
import { useEffect, useState } from 'react';
import { Term } from 'types/api';
import { errorHandler } from 'utils/ErrorHandler';
import { GET_INVOICE_LIST } from '..';
import { Invoices, SettlementInvoiceList } from '../types';

export interface InvoiceFilter {
  page: number;
  size: number;
  filter?: InvoiceFilterInput;
}

export interface InvoiceFilterInput {
  hostId?: string;
  statusIn?: InvoiceState[];
  term?: Term;
}

export function useQueryGetInvoiceList() {
  const [invoiceFilter, setInvoiceFilter] = useState<InvoiceFilter>({
    page: 1,
    size: 10,
    filter: {
      statusIn: [
        InvoiceState.READY,
        InvoiceState.PROGRESSING,
        InvoiceState.COMPLETED,
        InvoiceState.RECEIVED,
        InvoiceState.RECEIVE_REQUESTED,
      ],
      term: null,
    },
  });

  const { data, loading, refetch } = useQuery<SettlementInvoiceList>(
    GET_INVOICE_LIST,
    {
      variables: {
        page: 1,
        size: 10,
        filter: {
          statusIn: [
            InvoiceState.READY,
            InvoiceState.PROGRESSING,
            InvoiceState.COMPLETED,
            InvoiceState.RECEIVED,
            InvoiceState.RECEIVE_REQUESTED,
          ],
          term: null,
        },
      },
    },
  );

  const [invoices, setInvoices] = useState<Invoices>();

  const handleRefetchInvoice = async (filter: InvoiceFilter) => {
    try {
      const response = await refetch(filter);

      if (response) {
        setInvoices(response.data.settlement.invoices);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleLoadMoreInovice = async () => {
    try {
      const response = await refetch({
        ...invoiceFilter,
        page: invoiceFilter.page + 1,
      });

      if (response) {
        setInvoiceFilter({ ...invoiceFilter, page: invoiceFilter.page + 1 });
        setInvoices({
          ...invoices,
          pageInfo: response.data.settlement.invoices.pageInfo,
          edges: [
            ...invoices.edges,
            ...response.data.settlement.invoices.edges,
          ],
        });
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (!loading) {
      setInvoices(data.settlement.invoices);
    }
  }, [loading]);

  return {
    invoices,
    isLoading: loading,
    invoiceFilter,
    setInvoiceFilter,
    handleRefetchInvoice,
    handleLoadMoreInovice,
  };
}
